module.exports = __webpack_public_path__ + "img/om-logo-bg.22e8bf4b.png";